import { Typography } from "../../atoms/typography";
import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { SectionHeaderProps } from "./types";

/**
 * SectionHeader — caption-style group label for a `SidebarMenu.Section`.
 *
 * Renders a `caption-md` heading in `neutral/foreground-intermediate`. It is a
 * private part of `SidebarMenu`, exposed only as `SidebarMenu.SectionHeader`
 * (no standalone `@luce/ui` export) — it has a single consumer and the Figma
 * design treats it as a building block of the sidebar, not its own component.
 *
 * `displayName` is load-bearing: `SidebarMenu.Section` detects the header child
 * by `displayName === "SectionHeader"` to wire `aria-labelledby`.
 */
export const SectionHeader = ({ children, id, className, testID }: SectionHeaderProps) => (
  <Box
    {...platformProps({ testID, id, slot: "section-header" })}
    as="h3"
    className={cn("px-spacing-md py-spacing-sm", className)}
  >
    <Typography variant="caption-md" color="neutral-foreground-intermediate">
      {children}
    </Typography>
  </Box>
);

SectionHeader.displayName = "SectionHeader";
